import Clarity from "@microsoft/clarity"

const CLARITY_PROJECT_ID = "xns0t4acjk"

// Skipped outside production builds (pnpm dev) so local development doesn't
// pollute the Clarity dashboard with dev-server sessions. Preview deploys
// (Cloudflare Pages branch previews) run the same production build as the
// real site, so those are still tracked.
export function initClarity(): void {
  if (!import.meta.env.PROD) return
  Clarity.init(CLARITY_PROJECT_ID)
}

// Custom event, e.g. for the login funnel (login_started/login_completed) or
// favorite-list actions — shows up in Clarity's Filters/Smart events.
export function trackEvent(name: string): void {
  if (!import.meta.env.PROD) return
  Clarity.event(name)
}
